// Theme toggle — one site-wide dark mode switch.
// Applies [data-theme] to <html> and persists the choice to localStorage.

const STORAGE_KEY = 'app-radar-theme';
const VALID = new Set(['light', 'dark']);

/** @returns {'light'|'dark'} */
function loadPreference() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return VALID.has(stored) ? stored : 'dark';
}

/** @param {'light'|'dark'} value */
function applyTheme(value) {
  const normalized = value === 'dark' ? 'dark' : 'light';
  const root = document.documentElement;
  root.setAttribute('data-theme', normalized);
  localStorage.setItem(STORAGE_KEY, normalized);
}

/**
 * Initialise the theme toggle.
 * Reads localStorage, applies [data-theme], and wires up the #theme-toggle
 * change event. Safe to call before DOMContentLoaded if the <html> element
 * is the only target.
 */
export function initTheme() {
  const pref = loadPreference();
  applyTheme(pref);

  document.addEventListener('DOMContentLoaded', () => {
    const button = document.getElementById('theme-toggle');
    if (!button) return;
    const syncButton = () => {
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      const label = button.querySelector('.theme-toggle__label');
      if (label) label.textContent = isDark ? 'Light' : 'Dark';
      button.setAttribute('aria-pressed', String(isDark));
    };
    syncButton();
    button.addEventListener('click', () => {
      const next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      applyTheme(next);
      syncButton();
    });
  });
}
